import React, { useState, useEffect } from "react";
import { Button, Layout, Checkbox } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "./StudentRegistrationPage.css";
import Footer from "../../CommonComponents/AdminCommonCom/Footer";
import axios from "axios";
import { BranchMaster } from "../../../AllAPI/AdminAPI";
import hostelLogo from "../../../Assets/logo.png";

const { Header, Content } = Layout;

export default function StudentRegistrationPage2() {
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state?.formData || {};
  const formDataFromStorage = JSON.parse(localStorage.getItem("studentRegData") || "{}");

  const BranchId = formData.branch_id || formDataFromStorage.branch_id;

  const [branchName, setBranchName] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const terms = [
    "The student must follow all hostel rules and regulations.",
    "Damaging hostel property will result in penalties.",
    "Parents/guardians must be informed for any overnight outing.",
    "Hostel timing must be strictly followed.",
    "Misbehaviour towards staff or other students will not be tolerated.",
    "Mobile phones may be restricted during study hours.",
    "Hostel fees once paid are non-refundable.",
    "The student must follow all hostel rules and regulations.",
    "Damaging hostel property will result in penalties.",
    "Parents/guardians must be informed for any overnight outing.",
    "Hostel timing must be strictly followed.",
    "Misbehaviour towards staff or other students will not be tolerated.",
    "Mobile phones may be restricted during study hours.",
    "Hostel fees once paid are non-refundable.",
  ];

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(BranchMaster);
        const branches = response.data;

        const matched = branches.find(
          (item) => String(item.branch_id) === String(BranchId)
        );

        if (matched) {
          setBranchName(matched.branch_name);
        }
      } catch (err) {
        console.error("Error fetching branches:", err);
      }
    };

    fetchBranches();
  }, [BranchId]);

  return (
    <Layout className="registration-layout">

      {/* Header Section */}
      <Header className="registration-header" style={{ backgroundColor: "#235784" }}>
        <div className="logo-container">
          <img src={hostelLogo} alt="Logo" className="company-logo" />
          <span className="company-name">{branchName}</span>
        </div>
        <div className="nav-links">
          <Button type="link"
            onClick={() => navigate("/student-login")}
            style={{ border: "1px solid white", color: "white" }}>
            Login
          </Button>
        </div>
      </Header>

      {/* Main Content */}
      <Content className="registration-content">
        <div className="registration-form-container mb-5">

          <div className="header-row">
            <h2 className="page-title">Terms And Conditions</h2>
          </div>

          <div className="terms-box">
            {terms.map((item, index) => (
              <p key={index} className="terms-item">
                {index + 1}. {item}
              </p>
            ))}
          </div>

          <div className="checkbox-container">
            <Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
              I have read and agree to all the above terms & conditions.
            </Checkbox>
          </div>

          <div className="btn-row">
            <Button
              style={{ marginRight: "10px" }}
              onClick={() => navigate("/student/register")}
            >
              Back
            </Button>

            <Button
              type="primary"
              disabled={!isChecked}
              onClick={() => navigate("/student/registration", { state: { formData } })}
            >
              Next
            </Button>
          </div>

        </div>
      </Content>

      <Footer />
    </Layout>
  );
}
